import { UpdateCompanyPayload } from "@screens/company/hooks/useUpdateCompany";

type FieldSave = Omit<UpdateCompanyPayload, "id">;

/**
 * Folds a queued inline save into the one already waiting. Plain fields overwrite, but
 * `attribute_values` merges per attribute: each save carries only the field the user touched, so
 * replacing the array would drop an attribute queued moments earlier.
 */
export function mergeFieldSaves(pending: FieldSave | null, next: FieldSave): FieldSave {
  const merged: FieldSave = { ...pending, ...next };

  if (pending?.attribute_values?.length && next.attribute_values?.length) {
    const byAttribute = new Map(pending.attribute_values.map((value) => [value.attribute, value]));

    // Same attribute touched twice: the newer write wins.
    next.attribute_values.forEach((value) => byAttribute.set(value.attribute, value));

    merged.attribute_values = [...byAttribute.values()];
  }

  // Sticky: one shared-attribute write anywhere in the batch still reached the deal.
  if (pending?.hasSharedAttributeUpdates || next.hasSharedAttributeUpdates) {
    merged.hasSharedAttributeUpdates = true;
  }

  return merged;
}
